import React from 'react';
import {
	Icon,
	List,
	Popup
} from 'semantic-ui-react';
import { log } from '../../services/utils';

const PhoneValidationInfoPopup = () => {
	return (
		<Popup
			flowing
			position="top center"
			positionFixed
			trigger={
				<Icon
					name="info circle"
					size="large"
				/>
			}
		>
			{ log( '-phoneValidationInfoPopup' ) }
			<Popup.Content>
				<List>
					<List.Item>To be valid, a U.S. phone number must be 10 digits in length.</List.Item>
					<List.Item>(a 3-digit area code followed by a 7-digit telephone number)</List.Item>
				</List>
			</Popup.Content>
		</Popup>
	);
};

export default PhoneValidationInfoPopup;
